export namespace VentilationDiagnosticsHelpers {
  export function convertFilterRuntimeHours(hours: number, negative: boolean): string {
    if (hours >= 72) {
      return `${negative ? '-' : ''}${Math.round(hours / 24)} d`;
    } else {
      return `${negative ? '-' : ''}${hours} h`;
    }
  }
}
